<script setup>
	import { computed, onErrorCaptured, onMounted, ref } from "vue";
	import NoBsClassic from "@/views/NoBsPromotionClassic.vue";
	import NoBsTerminal from "@/views/NoBsPromotionTerminal.vue";
	import { trackPromoVariantView } from "@/services/analytics";

	const variantStorageKey = "noBsPromotionVariant";

	const variantComponents = {
		classic: NoBsClassic,
		terminal: NoBsTerminal,
	};

	const variantPages = {
		classic: "/no-bs-promotion-classic",
		terminal: "/no-bs-promotion-terminal",
	};

	const variantNames = Object.keys(variantComponents);
	const failedVariants = [];

	function readOverrideVariant() {
		try {
			const requestedVariant = new URLSearchParams(window.location.search).get("variant");
			return requestedVariant && variantNames.includes(requestedVariant) ? requestedVariant : null;
		} catch {
			return null;
		}
	}

	function readStoredVariant() {
		try {
			return window.localStorage.getItem(variantStorageKey);
		} catch {
			return null;
		}
	}

	function persistVariant(variant) {
		try {
			window.localStorage.setItem(variantStorageKey, variant);
		} catch {
		}
	}

	function resolveVariant() {
		if (typeof window === "undefined") {
			return variantNames[0];
		}

		const overrideVariant = readOverrideVariant();
		if (overrideVariant) {
			return overrideVariant;
		}

		const storedVariant = readStoredVariant();
		if (storedVariant && variantNames.includes(storedVariant)) {
			return storedVariant;
		}

		const assignedVariant = variantNames[Math.floor(Math.random() * variantNames.length)];
		persistVariant(assignedVariant);

		return assignedVariant;
	}

	const activeVariant = ref(resolveVariant());

	const activeVariantComponent = computed(() => variantComponents[activeVariant.value]);

	onMounted(() => {
		trackPromoVariantView(variantPages[activeVariant.value]);
	});

	onErrorCaptured((error) => {
		console.error(`[no-bs-promotion] the "${activeVariant.value}" variant failed to render:`, error);

		if (!failedVariants.includes(activeVariant.value)) {
			failedVariants.push(activeVariant.value);
		}

		const fallbackVariant = variantNames.find((variantName) => !failedVariants.includes(variantName));

		if (fallbackVariant) {
			persistVariant(fallbackVariant);
			activeVariant.value = fallbackVariant;
			trackPromoVariantView(variantPages[fallbackVariant]);
		}

		return false;
	});
</script>

<template>
	<component :is="activeVariantComponent" />
</template>